/**
 * @fileoverview POST handler for the "/databricks_deltashares/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postDeltasharesCacheKeys } from "./constants";
import type { MutateDeltasharesResult, PostDeltasharesProps } from "./types";

export const postDeltashares = reactQueryMutationAdapter(
  postDeltasharesCacheKeys,
  (props: PostDeltasharesProps): Promise<MutateDeltasharesResult> => {
    return fetch(`/databricks_deltashares/${props.appGroupId}`, "POST", props.datashare, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
